import "./App.css";

import {
  Routes,
  BrowserRouter as Router,
  Route,
  Navigate,
} from "react-router-dom";

import { SlidesContainer } from "./components/Slides/Slides.styled";
import SlideDeck from "./components/Slides/SlideDeck";
import LandingPage from "./modules/public/LandingPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/deck/:deckId"
          element={
            <SlidesContainer>
              <SlideDeck />
            </SlidesContainer>
          }
        />
        <Route path="error" element={<>Not found!</>} />
        <Route path="*" element={<Navigate to="/error?code=404" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
